var _defs, _path, _line, _path2, _path3, _line2, _path4, _path5, _path6, _polyline, _line3, _polyline2, _line4, _polyline3, _line5, _polyline4, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarePlusInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke-width:13.92px;}.cls-1,.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:12.5px;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m184.41,161.99h-50.59c-12.76,0-24.08,8.16-28.12,20.27l-4.29,12.86c-3.24,9.73-9.63,18.09-18.16,23.78h0c-12.83,8.55-20.53,22.95-20.53,38.36v42.91c0,9.89,8.02,17.91,17.91,17.91h35.81c6.12,0,12.18-1.14,17.88-3.36h0c5.7-2.22,11.76-3.36,17.88-3.36h32.22"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.75,
    y1: 219.93,
    x2: 184.41,
    y2: 219.93
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.46,320.13v20.28c0,5.86-4.75,10.62-10.62,10.62h-23.02c-5.86,0-10.62-4.75-10.62-10.62v-20.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.37,254.62h22.87c13.71,0,24.83,11.12,24.83,24.83v7.48h-49.08"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 152.88,
    y1: 286.94,
    x2: 184.41,
    y2: 286.94
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m65.11,221.28h-.87c-5.49,0-9.44-5.29-7.87-10.56l1.7-5.7c1.04-3.48,4.24-5.86,7.87-5.86h20.24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m235.48,110.24h-17.68c-7.54,0-13.65,6.11-13.65,13.65v231.12c0,7.54,6.11,13.65,13.65,13.65h161.08c7.54,0,13.65-6.11,13.65-13.65V123.89c0-7.54-6.11-13.65-13.65-13.65h-19.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m326.31,89.39v-2.54c0-3.84-3.12-6.96-6.96-6.96h-42.5c-3.84,0-6.96,3.12-6.96,6.96v2.54c0,3.84-3.12,6.96-6.96,6.96h0c-3.84,0-6.96,3.12-6.96,6.96v15.47c0,3.84,3.12,6.96,6.96,6.96h70.35c3.84,0,6.96-3.12,6.96-6.96v-15.47c0-3.84-3.12-6.96-6.96-6.96h0c-3.84,0-6.96-3.12-6.96-6.96Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "222.7 164.98 233.77 174.77 248.03 150.96"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.01,
    y1: 162.87,
    x2: 376.05,
    y2: 162.87
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "222.7 220.19 233.77 229.99 248.03 206.18"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.01,
    y1: 218.08,
    x2: 376.05,
    y2: 218.08
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "222.7 275.4 233.77 285.2 248.03 261.39"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.01,
    y1: 273.29,
    x2: 376.05,
    y2: 273.29
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "222.7 330.61 233.77 340.41 248.03 316.6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 267.01,
    y1: 328.51,
    x2: 376.05,
    y2: 328.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarePlusInspection);
export default __webpack_public_path__ + "static/media/carePlusInspection.dd0d072e9df1a83425401f83ddf1d2d5.svg";
export { ForwardRef as ReactComponent };